/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import { ReduxRouterState } from '@lagunovsky/redux-react-router';
import actionCreatorFactory from 'typescript-fsa/dist/typescript-fsa';
import { SystemPropertyState } from '../screens/SysAdmin/SystemProperties/reducer';
import { UserGroupState } from '../screens/UserGroupController/reducer';
import { UserMailState } from './AccountUserApp/AccountUserMail/reducer';
import { AccountUserProfilState } from './AccountUserApp/AccountUserProfile/reducer';
import { AccountUserSettingsState } from './AccountUserApp/AccountUserSettings/reducer';
import { UserSearchState } from './AccountUserApp/IncrementalUserSearch/reducer';
import { BettingStore } from './Betting/reducer';
import { NotificationStatusState } from './BettingApp/BettingProfile/NotificationStatus/reducer';
import { BettingProfileState } from './BettingApp/BettingProfile/reducer';
import { BettingViewState } from './BettingApp/BettingView/reducer';
import { HsdState } from './BettingApp/HighscoreStrategyDescriptorScreen/reducer';
import { MatchStatisticState } from './BettingApp/MatchStatistic/reducer';
import { MyGroupHighscoreState } from './BettingApp/MyGroupHighscores/reducer';
import { TournamentArchiveState } from './BettingApp/TournamentArchive/reducer';
import { HsdEditState } from './BettingApp/UserGroupHighscoreDescriptorDialog/reducer';
import { BlogState } from './BloggingApp/reducer';
import { GroupInternalHighscoreState } from './GroupInternalHighscores/reducer';
import { JobManagementState } from './JobManagement/reducer';
import { AlbumEditState } from './PlaylistAdminApp/AlbumEdit/reducer';
import { AlbumListState } from './PlaylistAdminApp/AlbumList/reducer';
import { PlaylistSearchState } from './PlaylistAdminApp/PlaylistSearch/reducer';
import { PlaylistStatisticState } from './PlaylistAdminApp/PlaylistStatistics/reducer';
import { SongEditState } from './PlaylistAdminApp/SongEdit/reducer';
import { SongListState } from './PlaylistAdminApp/SongList/reducer';
import { PortalState } from './RadioEins/Portal/reducer';
import { UserAdminState } from './SysAdminApp/UserAdmin/reducer';
import { ActionTokenState } from './System/ActionToken/reducer';
import { HtmlIncludeState } from './System/HtmlInclude/reducer';
import { SystemStore } from './System/reducer';
import { TeamChatState } from './TeamChat/reducer';
import { TournamentSelectionState } from './TournamentSelectionComponent/reducer';
import { GroupHighscoreStore } from './UserGroupHighscores/reducer';
import { UserGroupListStore } from './UserGroupList/reducer';
import { UserListStore } from './UserList/reducer';
import { UserViewState } from './UserView/reducer';
import { PortletState } from './common/RssPortlet/reducer';

export interface GlobalState {
    router: ReduxRouterState;
    groupHighscore: GroupHighscoreStore;
    userGroupList: UserGroupListStore;
    userList: UserListStore;
    system: SystemStore;
    betting: BettingStore;
    groupInternalHighscore: GroupInternalHighscoreState;
    playlistAdmin: {
        albumList: AlbumListState;
        albumEdit: AlbumEditState;
        songList: SongListState;
        playlistSearch: PlaylistSearchState;
        statistics: PlaylistStatisticState;
        songEdit: SongEditState;
    };
    htmlInclude: HtmlIncludeState;
    jobManagement: JobManagementState;
    userGroup: UserGroupState;
    tournamentSelection: TournamentSelectionState;
    bettingProfile: BettingProfileState;
    accountUserProfile: AccountUserProfilState;
    accountUserSettings: AccountUserSettingsState;
    userView: UserViewState;
    bettingView: BettingViewState;
    hsd: HsdState;
    hsdEdit: HsdEditState;
    notificationStatus: NotificationStatusState;
    userMail: UserMailState;
    userSearch: UserSearchState;
    portlet: PortletState;
    portal: PortalState;
    blog: BlogState;
    archive: TournamentArchiveState;
    userAdmin: UserAdminState;
    matchStatistic: MatchStatisticState;
    actionToken: ActionTokenState;
    myGroupHighscores: MyGroupHighscoreState;
    teamChat: TeamChatState;
    systemPropertyState: SystemPropertyState;
}

const actionCreator = actionCreatorFactory();

export const NO_OP_BOOL_ACTION = 'NO_OP_BOOL_ACTION';
export const noopBoolxAction = actionCreator<boolean>(NO_OP_BOOL_ACTION);
